<mat-expansion-panel
  class="flotante-panel"
  [expanded]="expansionPanelExpanded"
  (expandedChange)="expansionPanelExpanded = $event"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">doorbell</mat-icon>
      <span class="panel-title">Alarmas</span>
      <span class="counter-badge">
        {{ alarmasFiltradas.length }}
        @if (alarmasFiltradas.length !== (alarmas?.length ?? 0)) {
          / {{ alarmas?.length ?? 0 }}
        }
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- BUSCADOR + BOTÓN FILTROS -->
  <div class="seccion top-bar">
    <div class="buscador-wrapper">
      <mat-icon class="search-icon material-symbols-outlined">search</mat-icon>
      <input
        type="text"
        class="buscador-input"
        placeholder="Buscar..."
        [(ngModel)]="textoBusqueda"
        (ngModelChange)="onBusquedaChange()"
      />
      @if (textoBusqueda) {
        <button
          irxBotonIcono
          tamano="mini"
          class="clear-btn"
          (click)="limpiarBusqueda()"
          tooltip="Limpiar búsqueda"
        >
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      }
    </div>

    <button
      irxBotonIcono="borde"
      tamano="compacto"
      class="btn-filtros"
      [activo]="hayFiltrosModalActivos"
      (click)="abrirDialogFiltros()"
      tooltip="Abrir filtros"
    >
      <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
      @if (hayFiltrosModalActivos) {
        <span class="filter-badge"></span>
      }
    </button>

    @if (hayBusquedaOFiltrosModal) {
      <button
        irxBotonIcono="borde"
        tamano="compacto"
        class="btn-filtros btn-reset"
        (click)="limpiarSoloFiltros()"
        tooltip="Limpiar filtros"
      >
        <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      </button>
    }
  </div>

  <!-- CAPAS -->
  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <div class="poligonos-pills">
      <!-- Mostrar: clusters + vehiculos de seguridad privada. Un solo grupo,
           como el "Mostrar" (clusters + gateways) del flotante de luminarias. -->
      <div class="pill-item">
        <irx-segmentado class="visibility-toggle-group" tamano="compacto">
          <irx-segmento
            (click)="onToggleCluster()"
            [activo]="clusterEnabled"
            tooltip="Mostrar/Ocultar clusters"
          >
            <mat-icon class="material-symbols-outlined">
              {{ clusterEnabled ? 'blur_on' : 'blur_off' }}
            </mat-icon>
          </irx-segmento>

          @if (vehiculosSeguridadPrivada?.length) {
            <irx-segmento
              (click)="onToggleSeguridadPrivada()"
              [activo]="seguridadPrivadaEnabled"
              [tooltip]="
                (seguridadPrivadaEnabled ? 'Ocultar' : 'Mostrar') +
                ' vehículos de seguridad privada (' +
                vehiculosSeguridadPrivada.length +
                ')'
              "
            >
              <mat-icon class="material-symbols-outlined">
                {{ seguridadPrivadaEnabled ? 'security' : 'shield_moon' }}
              </mat-icon>
            </irx-segmento>
          }
        </irx-segmentado>
        <span class="pill-label">Mostrar</span>
      </div>

      <!-- Polígonos de zonas -->
      @if (zonas?.length) {
        <div class="pill-item">
          <irx-segmentado class="visibility-toggle-group" tamano="compacto">
            <irx-segmento
              (click)="onTogglePoligonoZonas()"
              [activo]="poligonoZonasEnabled"
              tooltip="Mostrar/Ocultar polígonos de zonas"
            >
              <mat-icon class="material-symbols-outlined">
                {{ poligonoZonasEnabled ? 'hexagon' : 'pentagon' }}
              </mat-icon>
            </irx-segmento>

            <irx-segmento
              (click)="onToggleTextoZonas()"
              [disabled]="!poligonoZonasEnabled"
              [tooltip]="
                textoZonasEnabled
                  ? 'Ocultar nombres de zonas'
                  : 'Mostrar nombres de zonas'
              "
            >
              <mat-icon>
                {{ textoZonasEnabled ? 'match_case' : 'match_case_off' }}
              </mat-icon>
            </irx-segmento>
          </irx-segmentado>
          <span class="pill-label">Zonas</span>
        </div>
      }
    </div>
  </div>

  <!-- ESTADOS -->
  @if (estados?.length) {
    <div class="seccion">
      <div class="seccion-titulo seccion-titulo-row">
        <span>Estados</span>
        @if (hayEstadosFiltrados) {
          <button
            irxBotonIcono
            tamano="mini"
            class="btn-reset-inline"
            (click)="limpiarSoloEstados()"
            tooltip="Restaurar todos los estados"
          >
            <mat-icon class="material-symbols-outlined">refresh</mat-icon>
          </button>
        }
      </div>
      <div class="estados-grid">
        @for (estado of estados; track estado.nombre) {
          <button
            type="button"
            class="irx-chip irx-chip--multilinea capa-chip estado-chip"
            [attr.aria-pressed]="filtrosEstado.includes(estado.nombre)"
            (click)="toggleEstado(estado.nombre)"
            [tooltip]="estado.nombre"
          >
            <span class="estado-icon-bg">
              <mat-icon class="material-symbols-outlined estado-icon">
                {{ estado.icono }}
              </mat-icon>
            </span>
            <span class="capa-label">{{ estado.nombre }}</span>
            <span class="capa-count">{{ estado.cant }}</span>
          </button>
        }
      </div>
    </div>
  }

  @if (hayFiltrosActivos) {
    <button
      irxBoton="secundario"
      type="button"
      class="limpiar-btn"
      (click)="limpiarFiltros()"
    >
      <mat-icon class="material-symbols-outlined">filter_alt_off</mat-icon>
      Limpiar todo
    </button>
  }
</mat-expansion-panel>
